import { ActionTree } from 'vuex';
import { TblLieferantenState } from './types';
import { RootState } from '../../types';
import { defaultBackendTblLieferanten } from '@/shared/backend/tblLieferanten';
import {
  LieferantenFacetSearchData,
  LieferantenSearchData,
} from '@/shared/model/smallPayloadModels/lieferantenSearchData';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import tblLieferanten, { Value, TblLieferanten } from '@/shared/model/tblLieferanten';
import { defaultBackendTblKollegenauslieferung } from '@/shared/backend/tblKollegenauslieferung';
import { AxiosResponse } from 'axios';
import DownloadUtils from '@/shared/utils/DownloadUtils';
import i18n from '@/i18n';

export const actions: ActionTree<TblLieferantenState, RootState> = {
  getLieferanteng(
    { commit, dispatch, getters, rootGetters },
    payload?: { searchParams?: any; lieferantenSearchData?: any }
  ) {
    commit('setTblLieferantensIsLoading', true);
    let searchParams = payload?.searchParams ?? getters.getLieferantenSearchData;
    let searchData = payload?.lieferantenSearchData ?? {};
    return defaultBackendTblLieferanten
      .getLieferanteng(searchParams, searchData)
      .then((response: AxiosResponse<Value>) => {
        commit('setTblLieferantens', response.data);
        commit('setTblLieferantensIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setTblLieferantensIsLoading', false);
        throw e;
      });
  },
  getZrNumberList({ commit, dispatch }, payload?: { lieferantenSearchData?: any }) {
    return defaultBackendTblLieferanten
      .getZrNumberList(payload?.lieferantenSearchData)
      .then((response: AxiosResponse<any>) => {
        return response.data;
      })
      .catch((e: any) => {
        throw e;
      });
  },
  getStatusCompaniesList({ commit, dispatch }, payload?: { lieferantenSearchData?: any }) {
    return defaultBackendTblLieferanten
      .getStatusCompaniesList(payload?.lieferantenSearchData)
      .then((response: AxiosResponse<any>) => {
        return response.data;
      })
      .catch((e: any) => {
        throw e;
      });
  },
  getHauptwarengruppenList({ commit, dispatch }, payload?: { lieferantenSearchData?: any }) {
    return defaultBackendTblLieferanten
      .getHauptwarengruppenList(payload?.lieferantenSearchData)
      .then((response: AxiosResponse<any>) => {
        return response.data;
      })
      .catch((e: any) => {
        throw e;
      });
  },
  getLieferantenFacetSearch({ commit, dispatch }, payload: LieferantenFacetSearchData) {
    return defaultBackendTblLieferanten
      .getLieferantenFacetSearch(payload)
      .then((response: AxiosResponse<any>) => {
        const result = response.data.$values ? response.data.$values : response.data;
        return result;
      })
      .catch((e: any) => {
        throw e;
      });
  },
  outputLieferantengData(
    { commit, dispatch, getters, rootGetters },
    payload?: { searchParams?: any; lieferantenSearchData?: any }
  ) {
    commit('setTblLieferantensIsLoading', true);
    let searchParams = payload?.searchParams ?? getters.getLieferantenSearchData;
    let searchData = payload?.lieferantenSearchData ?? {};
    return defaultBackendTblLieferanten
      .outputLieferantengData(searchParams, searchData)
      .then((response: AxiosResponse<Value>) => {
        commit('setTblLieferantensIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setTblLieferantensIsLoading', false);
        throw e;
      });
  },
  getLieferantengDataReport({ commit, dispatch }, payload?: { outputLieferantenData?: any }) {
    let outputLieferantenData = payload?.outputLieferantenData || {};
    commit('setTblLieferantensIsLoading', true);
    return defaultBackendTblLieferanten
      .getLieferantengDataReport(outputLieferantenData)
      .then((response: any) => {
        if (response.headers['content-disposition']) {
          const fileName = DownloadUtils.getFileName(response.headers['content-disposition']);
          const type = response.headers['content-type'];
          const blob = new Blob([response.data], { type: type });
          const url = DownloadUtils.createDownloadLink(blob, fileName);
          window.URL.revokeObjectURL(url);
        }
        commit('setTblLieferantensIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setTblLieferantensIsLoading', false);
        throw e;
      });
  },
  getLieferantenExcelReport({ commit, dispatch }, payload?: { outputExcelReport?: any }) {
    let outputLieferantenData = payload?.outputExcelReport || {};
    commit('setTblLieferantenReportIsLoading', true);
    return defaultBackendTblLieferanten
      .getLieferantenExcelReport(outputLieferantenData)
      .then((response: any) => {
        if (response.headers['content-disposition']) {
          const fileName = DownloadUtils.getFileName(response.headers['content-disposition']);
          const type = response.headers['content-type'];
          const blob = new Blob([response.data], { type: type });
          const url = DownloadUtils.createDownloadLink(blob, fileName);
          window.URL.revokeObjectURL(url);
        }
        commit('setTblLieferantenReportIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setTblLieferantenReportIsLoading', false);
        throw e;
      });
  },
  createLieferantenFileLogRecord({ commit, dispatch }, payload?: { type: any; email: any }) {
    return defaultBackendTblLieferanten
      .createLieferantenFileLogRecord(payload)
      .then((response: AxiosResponse<any>) => {
        return response;
      })
      .catch((e: any) => {
        module_utils.error('createBonusLogRecords error', commit, e);
        throw e;
      });
  },
  updateLieferantenSearchData({ commit, dispatch }, data: any) {
    commit('setLieferantenSearchData', data);
  },
};
